import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import router from './router'
import App from './App.vue'

const app = createApp(App)
for (const iconName in ElementPlusIconsVue) {
	app.component(iconName, ElementPlusIconsVue[iconName])
}
app.use(ElementPlus)
app.use(router)
app.mount('#app')
